import React, { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import enhanceMessage from './enhanceMessage';
import { TwilioError } from 'twilio-video';
import { ModalUI } from '../UI/Modal/Modal';
import { ErrorDialogStyle } from './style';
import ButtonUI from '../UI/Button/Button';

interface ErrorDialogProps {
  dismissError: Function;
  error: TwilioError | null;
}

function ErrorDialog({ dismissError, error }: PropsWithChildren<ErrorDialogProps>) {
  const { t } = useTranslation();
  const { message, code } = error || {};
  const enhancedMessage = enhanceMessage(message, code);
  const { errorModal, container, titleText, messageText, errorCodeBlock, actions } = ErrorDialogStyle;
  const handleClose = (_event: {}, _reason: 'backdropClick' | 'escapeKeyDown') => {
    dismissError();
  };

  return (
    <ModalUI className={'error-modal'} open={error !== null} onCloseHandler={handleClose} modalSx={errorModal}>
      <Box sx={container}>
        <Typography variant="h6" sx={titleText}>
          {t('error-dialog')}
        </Typography>
        <Typography variant="body1" sx={messageText}>
          {enhancedMessage}
        </Typography>
        {code && (
          <Box component="pre" sx={errorCodeBlock}>
            <code>Error Code: {code}</code>
          </Box>
        )}
        <Box sx={actions}>
          <ButtonUI onClickHandler={() => dismissError()} text="OK" variant="text" type="modalText" autoFocus />
        </Box>
      </Box>
    </ModalUI>
  );
}

export default ErrorDialog;
